"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rebass_1 = require("rebass");
const styled_components_1 = __importDefault(require("styled-components"));
const one_point_sdk_1 = require("@fozg/one-point-sdk");
const Avatar_1 = __importStar(require("../Avatar"));
const OnePointSDKBase_1 = require("../OnePointSDKBase");
function default_1() {
    const { data } = one_point_sdk_1.useFetch(() => OnePointSDKBase_1.OPSDK.getAppByName("fozg-elements").getListByName("apps").getItems(), []);
    return (react_1.default.createElement(rebass_1.Box, { width: 360 },
        react_1.default.createElement(rebass_1.Box, { ml: 15 },
            react_1.default.createElement(rebass_1.Text, { fontWeight: 500, fontSize: 15 }, "More apps")),
        react_1.default.createElement(rebass_1.Flex, { flexWrap: "wrap", padding: 10 }, data.map((app) => (react_1.default.createElement(AppItem, { href: app.url, target: "_blank" },
            react_1.default.createElement(Avatar_1.default, { url: app.image_url, size: Avatar_1.AvatarSize.sm, rounded: false }),
            react_1.default.createElement(rebass_1.Text, { fontWeight: 500, ml: 2, fontSize: ".8rem" }, app.title)))))));
}
exports.default = default_1;
const AppItem = styled_components_1.default.a `
    padding: 8px;
    display: flex;
    align-items: center;
    width: 45%;
    border-radius: 10px;
    text-decoration: none;
    color: #000;
    :visited {
        color: #000;
    }
    :hover {
        cursor: pointer;
        box-shadow: 0 5px 8px rgba(0, 0, 0, 0.08);
    }
`;
//# sourceMappingURL=AppLists.js.map